import React, { useRef } from "react"
import SearchIcon from "@mui/icons-material/Search"
import { IconButton, InputAdornment } from "@mui/material"
import useDebounce from "../../hooks/useDebounce"

import * as S from "./custom-input-filter.styles"

const CustomInputFilter = ({ name, setValue }) => {
  const ref = useRef()

  const handleChange = () => {
    setValue(ref?.current?.value)
  }
  return (
    <S.CustomFormControl variant="outlined">
      <S.CustomLabel htmlFor="outlined-adornment-password">
        {name}
      </S.CustomLabel>
      <S.CustomInput
        type="search"
        onChange={handleChange}
        endAdornment={
          <InputAdornment position="end">
            <IconButton disabled>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        }
        label={name}
        inputRef={ref}
      />
    </S.CustomFormControl>
  )
}

export default CustomInputFilter
